import { render } from "./FooterItems.vue?vue&type=template&id=3fab6630"
import script from "./FooterItems.vue?vue&type=script&lang=js"
export * from "./FooterItems.vue?vue&type=script&lang=js"

import "./FooterItems.vue?vue&type=style&index=0&id=3fab6630&lang=scss"

import exportComponent from "/Users/yanislav.pavlov/development/private/bulgartabac/bulgartabac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__